<template>
  <div class="counselor-card__review">
    <p class="counselor-card__review-text">
      <a
        :href="link"
        v-html="truncateString(post.review)"
      />
    </p>
    <p class="counselor-card__review-footer">
      <span
        v-if="post.customer_name"
        class="counselor-card__review-name"
        v-text="post.customer_name"
      /><span v-if="!hideReviewDate" class="counselor-card__review-date">
        {{ timeSinceDate(post.review_date) }}
      </span>
    </p>
  </div>
</template>

<script>
import { useDateFormatter } from 'Composables/useDateFormatter';

export default {
  name: 'CounselorArchiveCardSingleReview',

  setup() {
    const { timeSinceDate, toValidDate, getLocale } = useDateFormatter();
    return { timeSinceDate, toValidDate, getLocale };
  },

  props: {
    post: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      hideReviewDate: !!theme_vars.hideReviewDate,
    };
  },

  methods: {
    truncateString(string) {
      if (string.length <= 80) {
        return string;
      }
      return `${string.slice(0, 80)}&hellip;`;
    },
  },
};
</script>
